import { useState, useEffect, useRef } from "react";
import React from "react";
import axios from "axios";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

// import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { Controller, useForm } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import "react-confirm-alert/src/react-confirm-alert.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  TextField,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import Container from "@mui/material/Container";
import { useAlert } from "react-alert";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Modal from "@mui/material/Modal";
import EditIcon from "@mui/icons-material/Edit";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

const Template = (props) => {
  const rights = useSelector((state) => state.login.rights);

  document.title = "Template | LuxBilling";
  const fields = [
    "id",
    "patientId",
    "practiceId",
    "providerId",
    "inActive",
    "createdDate",
    "updatedDate",
    "createdBy",
    "updatedBy",
    "name",
    "text",
    "istemplate",
    "userId",
    "therapistId",
    "supervisorId",
  ];
  const defValues = {
    id: 0,
    patientId: 0,
    practiceId: 0,
    providerId: 0,
    inActive: false,
    createdDate: "",
    updatedDate: "",
    createdBy: "",
    updatedBy: "",
    name: "",
    text: "",
    istemplate: false,
    userId: 0,
    therapistId: 0,
    supervisorId: 0,
  };
  const alert = useAlert();
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" } ,{ list: "check" },],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["blockquote", "code-block"],
      ["clean"],
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "list",
    "bullet",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "blockquote",
    "code-block",
  ];

  const {
    register,
    control,
    handleSubmit,
    getValues,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
  });

  const [refresh, setRefresh] = useState(false);
  const [ApiCall, setApiCall] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [OpenModal, setOpenModal] = React.useState(false);
  const [rowId, setRowID] = React.useState(0);

  const HandleOpen = () => {
    setOpenModal(true);
  };
  const HandleCloseModal = () => {
    setOpenModal(false);
    fields.forEach((field) => setValue(field, ""));
    reset();
    setRowID(0);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/Template/getTemplateById`, {
        headers,
        params: {
          name: searchTerm || "",
        },
      })
      .then((response) => {
        const data = Array.isArray(response) ? response : [response];
        data.forEach((item) => {
          if (!item.createdDate) {
            item.createdDate = new Date().toISOString();
          }
        });
        setRows(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [ApiCall, refresh]);

  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      setApiCall((prev) => !prev);
      setRefresh((prev) => !prev);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    setApiCall((prev) => !prev);
    setRefresh((prev) => !prev);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: 450,
    width: "50%",
    bgcolor: "white",
    border: "2px solid black",
    boxShadow: 24,
    borderRadius: "8px",
  };

  const handleSubmit1 = (data) => {
    let postData = {
      ...data,
      id: rowId || 0,
      createdDate: data.createdDate || new Date().toISOString(),
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Template/AddTemplate`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting && setSubmitting(false);
        setRefresh(true);
        setApiCall(!ApiCall);
        HandleCloseModal();

        Swal.fire({
          title: "Success!",
          text: "Template Added Successfully!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      })
      .catch((error) => {
        setSubmitting && setSubmitting(false);
        console.error("Error submitting data:", error);

        Swal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          showConfirmButton: true,
        });
      });
  };

  const [editStates, setEditStates] = useState({});
  const [previousTexts, setPreviousTexts] = useState({});
  const [enabledButtons, setEnabledButtons] = useState({});
  const [newFieldIndices, setNewFieldIndices] = useState({});
  // useState
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [apiTrigger, setApiTrigger] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);

  const [editModeByTemplate, setEditModeByTemplate] = useState({});
  const [previousFieldValues, setPreviousFieldValues] = useState({});
  const [saveEnabledByTemplate, setSaveEnabledByTemplate] = useState({});
  const [newFieldIndexes, setNewFieldIndexes] = useState({});

  const handleToggleEdit = (
    templateIndex,
    textIndex,
    templateId,
    currentText
  ) => {
    const isEditing = editStates[templateId]?.[textIndex] || false;

    if (isEditing) {
      const previous = previousTexts[templateId]?.[textIndex];
      if (previous !== undefined) {
        handleFieldChange(templateIndex, textIndex, previous);
      }
    } else {
      setPreviousTexts((prev) => ({
        ...prev,
        [templateId]: {
          ...(prev[templateId] || {}),
          [textIndex]: currentText,
        },
      }));
    }

    setEditStates((prev) => ({
      ...prev,
      [templateId]: {
        ...(prev[templateId] || {}),
        [textIndex]: !isEditing,
      },
    }));
  };

  const handleAddField = (templateIndex) => {
    const updatedRows = [...rows];
    const current = updatedRows[templateIndex];
    const textArray = current.text ? current.text.split("|||") : [];

    // 👇 ab empty string push karne ke bajaye ek placeholder lagao
    textArray.push("__NEW_FIELD__");

    current.text = textArray.join("|||");
    updatedRows[templateIndex] = current;
    setRows(updatedRows);

    const templateId = current.id;
    const newIndex = textArray.length - 1;

    setEditStates((prev) => ({
      ...prev,
      [templateId]: {
        ...(prev[templateId] || {}),
        [newIndex]: true, // edit mode on
      },
    }));

    setPreviousTexts((prev) => ({
      ...prev,
      [templateId]: {
        ...(prev[templateId] || {}),
        [newIndex]: "",
      },
    }));

    setNewFieldIndices((prev) => ({
      ...prev,
      [templateId]: [...(prev[templateId] || []), newIndex],
    }));
  };

  const handleFieldChange = (templateIndex, textIndex, newText) => {
    const updatedRows = [...rows];
    const textArray = updatedRows[templateIndex].text.split("|||");
    textArray[textIndex] = newText;
    setEnabledButtons((prev) => ({ ...prev, [templateIndex]: true }));
    updatedRows[templateIndex].text = textArray.join("|||");
    setRows(updatedRows);
  };

  const handleFieldDelete = (templateIndex, textIndex) => {
    confirmAlert({
      message: "Do you want to delete the record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const updatedRows = [...rows];
            const textArray = updatedRows[templateIndex].text.split("|||");
            textArray.splice(textIndex, 1);
            updatedRows[templateIndex].text = textArray.join("|||");

            const postData = {
              id: updatedRows[templateIndex].id,
              text: updatedRows[templateIndex].text,
              name: updatedRows[templateIndex].name,
            };

            axios
              .post(
                `${process.env.REACT_APP_API_URL}/Template/AddTemplate`,
                postData,
                { headers }
              )
              .then(() => {
                setRows(updatedRows);
                setApiCall((prev) => !prev);
                setEditStates((prev) => {
                  const newEditStates = { ...prev };
                  delete newEditStates[updatedRows[templateIndex].id]?.[
                    textIndex
                  ];
                  return newEditStates;
                });
                setPreviousTexts((prev) => {
                  const newPreviousTexts = { ...prev };
                  delete newPreviousTexts[updatedRows[templateIndex].id]?.[
                    textIndex
                  ];
                  return newPreviousTexts;
                });
              })
              .catch((err) => {
                console.error("There was an error!", err);
              });
          },
        },
        { label: "No" },
      ],
    });
  };

  const handleCancelField = (templateIndex, textIndex) => {
    const updatedRows = [...rows];
    const current = updatedRows[templateIndex];
    const textArray = current.text.split("|||");
    if (newFieldIndices[current.id]?.includes(textIndex)) {
      textArray.splice(textIndex, 1);
      current.text = textArray.join("|||") || "";
      updatedRows[templateIndex] = current;
      setRows(updatedRows);
      setEditStates((prev) => {
        const newEditStates = { ...prev };
        delete newEditStates[current.id]?.[textIndex];
        return newEditStates;
      });
      setPreviousTexts((prev) => {
        const newPreviousTexts = { ...prev };
        delete newPreviousTexts[current.id]?.[textIndex];
        return newPreviousTexts;
      });
      setNewFieldIndices((prev) => {
        const newIndices =
          prev[current.id]?.filter((i) => i !== textIndex) || [];
        return { ...prev, [current.id]: newIndices };
      });
    }
  };

  const handleDeleteTemplate = (id) => {
    confirmAlert({
      message: "Do you want to delete the record.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const postData = { inActive: true, id };
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/Template/AddTemplate`,
                postData,
                { headers }
              )
              .then(() => {
                setRefresh((prev) => !prev);
                setApiCall((prev) => !prev);
              })
              .catch((error) => {
                console.error("There was an error!", error);
              });
          },
        },
        { label: "No" },
      ],
    });
  };

  const handleSave = (template) => {
    const textArray = template.text.split("|||");
    const postData = {
      id: template.id,
      text: template.text,
      name: template.name,
      createdDate: template.createdDate || new Date().toISOString(),
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Template/AddTemplate`, postData, {
        headers,
      })
      .then((response) => {
        Swal.fire({
          title: "Success!",
          text: "Template Saved Successfully!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        setApiCall((prev) => !prev);
        setEnabledButtons((prev) => ({
          ...prev,
          [rows.findIndex((r) => r.id === template.id)]: false,
        }));
        setEditStates({});
        setPreviousTexts({});
        setNewFieldIndices((prev) => {
          const newIndices = { ...prev };
          delete newIndices[template.id];
          return newIndices;
        });
      })
      .catch((err) => {
        console.error("Save failed:", err);
        alert("Error saving data. Please check the console for details.");
      });
  };

  return (
    <div className="page-content">
      <Container>
        <Modal
          open={OpenModal}
          onClose={HandleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Headroom>
              <Grid
                container
                style={{ backgroundColor: "#356F60", position: "sticky" }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "3rem",
                      padding: "8px",
                    }}
                  >
                    <DialogTitle style={{ flex: 1 }}>
                      <h1
                        style={{
                          fontWeight: "bold",
                          margin: 0,
                          color: "#fff",
                          textDecoration: "underline",
                          fontSize: "1.2rem",
                        }}
                      >
                        Add Template
                      </h1>
                    </DialogTitle>
                    <IconButton
                      onClick={HandleCloseModal}
                      style={{
                        color: "red",
                        backgroundColor: "rgba(255, 77, 77, 0.1)",
                        borderRadius: "50%",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <CancelOutlinedIcon fontSize="medium" />
                    </IconButton>
                  </div>
                </Grid>
              </Grid>
            </Headroom>
            <form onSubmit={handleSubmit(handleSubmit1)}>
              <Grid
                container
                spacing={2}
                style={{
                  padding: "20px",
                  maxHeight: 390,
                  overflowY: "auto",
                  color: "#000",
                }}
              >
                <Grid item xs={12}>
                  <InputLabel>Name</InputLabel>
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: "Full Name is required" }}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        placeholder="Name"
                        {...field}
                        fullWidth
                        error={!!errors.name}
                        helperText={errors.name?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel>Text</InputLabel>
                  <Controller
                    name="text"
                    control={control}
                    rules={{ required: "Text is required" }}
                    render={({ field }) => (
                      <>
                        <ReactQuill
                          value={field.value}
                          onChange={(content, delta, source, editor) => {
                            setValue("text", content);
                          }}
                          modules={modules}
                          formats={formats}
                          theme="snow"
                          style={{
                            backgroundColor: "white",
                            borderRadius: "5px",
                            height: "300px",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        />
                        <style>
                          {`
                            .ql-toolbar {
                              border-top-left-radius: 5px;
                              border-top-right-radius: 5px;
                            }
                            .ql-container {
                              flex: 1;
                              border-bottom-left-radius: 5px;
                              border-bottom-right-radius: 5px;
                              overflow-y: auto;
                            }
                            .ql-editor {
                              height: 100%;
                              padding: 10px;
                            }
                          `}
                        </style>
                        {field.value.length === 0 && (
                          <p style={{ color: "red" }}>Text Is Empty</p>
                        )}
                        {errors.text && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "4px",
                              marginLeft: "2px",
                            }}
                          >
                            {errors.text.message}
                          </p>
                        )}
                      </>
                    )}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <Button
                    className="Button"
                    fullWidth
                    type="submit"
                    style={{
                      borderRadius: "10px",
                      color: "white",
                      height: "40px",
                      backgroundColor: "#28a745",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Save
                  </Button>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <Button
                    className="Button"
                    onClick={HandleCloseModal}
                    fullWidth
                    style={{
                      borderRadius: "10px",
                      color: "white",
                      height: "40px",
                      backgroundColor: "#dc3545",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Modal>

        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} md={2}>
              {rights.Add_Templates && (
                <Button
                  className="Button"
                  variant="contained"
                  onClick={HandleOpen}
                  fullWidth
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    color: "white",
                    backgroundColor: "#28a745",
                  }}
                >
                  <AddOutlinedIcon
                    fontSize="medium"
                    style={{ color: "white", marginRight: "6px" }}
                  />
                  Add New
                </Button>
              )}
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                label="Search Template"
                variant="outlined"
                size="small"
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Grid>

            <Grid item md={1.5}>
              <Button
                variant="contained"
                className="Button"
                onClick={handleSearch}
                fullWidth
                style={{
                  height: "40px",
                  color: "white",
                  backgroundColor: "#1976d2",
                }}
              >
                <SearchIcon style={{ marginRight: "6px", color: "white" }} />
                Search
              </Button>
            </Grid>

            <Grid item md={1.5}>
              <Button
                variant="contained"
                className="Button"
                onClick={handleClear}
                fullWidth
                style={{
                  height: "40px",
                  color: "white",
                  backgroundColor: "#dc3545",
                }}
              >
                <ClearIcon style={{ marginRight: "6px", color: "white" }} />
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={4}
            style={{
              padding: "20px",
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              margin: "10px auto",
              width: "100%",
              border: "2px solid #326C1D",
            }}
          >
            {isLoading ? (
              <div style={{ margin: "5rem", textAlign: "center" }}>
                <CircularProgress />
              </div>
            ) : rows.length > 0 ? (
              rows.map((s, index) => {
                const templateId = s.id;
                const textArray = s.text ? s.text.split("|||") : [];
                return (
                  <Grid
                    container
                    key={s.id}
                    style={{
                      padding: "20px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      width: "100%",
                      border: "2px solid #326C1D",
                    }}
                  >
                    <Grid item xs={12} style={{ marginTop: "20px" }}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="rights-content"
                          id="rights-header"
                          style={{
                            color: "#2e7d32",
                            backgroundColor: "#f1f8e9",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "25px",
                              fontWeight: "bold",
                              marginTop: 3,
                            }}
                          >
                            {s.name}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid
                            item
                            xs={12}
                            style={{ textAlign: "right", marginBottom: "16px" }}
                          >
                            <Button
                              // className="Button"
                              onClick={() => handleAddField(index)}
                              style={{
                                color: "white",
                                // backgroundColor: "#28a745",
                              }}
                            >
                              <AddOutlinedIcon
                                fontSize="medium"
                                style={{ color: "#28a745", marginRight: "6px" }}
                              />
                            </Button>
                          </Grid>
                          {textArray.length === 0 ? (
                            <Grid item md={12}  xs={12} sm={12} style={{ textAlign: "center" }}>
                              <Typography variant="h6">
                                No Fields Available
                              </Typography>
                            </Grid>
                          ) : (
                            textArray.map((text, textIndex) => {
                              const isEditing =
                                editStates[templateId]?.[textIndex] || false;
                              const isNewField =
                                newFieldIndices[templateId]?.includes(
                                  textIndex
                                ) || false;
                              return (
                                <Grid
                                  container
                                  key={`${s.id}-${textIndex}`}
                                  style={{
                                    marginBottom: "20px",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Grid
                                    item
                                    xs={0.5}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        backgroundColor: "#E9E9EE",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography>{textIndex + 1}</Typography>
                                    </Box>
                                  </Grid>

                                  <Grid
                                    item
                                    xs={9.5}
                                    style={{
                                      padding: "0 10px",
                                      maxWidth: "calc(100% - 140px)",
                                    }}
                                  >
                                    {isEditing ||
                                    isNewField ||
                                    text === "__NEW_FIELD__" ? (
                                      <ReactQuill
                                        value={
                                          text === "__NEW_FIELD__" ? "" : text
                                        }
                                        onChange={(content) =>
                                          handleFieldChange(
                                            index,
                                            textIndex,
                                            content
                                          )
                                        }
                                        modules={modules}
                                        formats={formats}
                                        theme="snow"
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "5px",
                                          marginBottom: "10px",
                                        }}
                                        readOnly={false}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "10px",
                                          backgroundColor: "#f9f9f9",
                                          wordBreak: "break-word",
                                          overflowX: "auto",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: text,
                                        }}
                                      />
                                    )}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={2}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: "5px",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    {isEditing && !isNewField ? (
                                      <IconButton
                                        onClick={() =>
                                          handleToggleEdit(
                                            index,
                                            textIndex,
                                            templateId,
                                            text
                                          )
                                        }
                                      >
                                        <CancelOutlinedIcon
                                          style={{
                                            color: "red",
                                            fontSize: "22px",
                                          }}
                                        />
                                      </IconButton>
                                    ) : (
                                      <IconButton
                                        onClick={() =>
                                          handleToggleEdit(
                                            index,
                                            textIndex,
                                            templateId,
                                            text
                                          )
                                        }
                                      >
                                        {!isNewField && (
                                          <EditIcon
                                            style={{
                                              color: "blue",
                                              fontSize: "22px",
                                            }}
                                          />
                                        )}
                                      </IconButton>
                                    )}

                                    {isNewField && (
                                      <IconButton
                                        onClick={() =>
                                          handleCancelField(index, textIndex)
                                        }
                                      >
                                        <ClearOutlinedIcon
                                          style={{
                                            color: "red",
                                            fontSize: "30px",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                    {!isNewField && rights.Delete_Templates && (
                                      <IconButton
                                        onClick={() =>
                                          handleFieldDelete(index, textIndex)
                                        }
                                      >
                                        <DeleteIcon
                                          style={{
                                            color: "red",
                                            fontSize: "22px",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </Grid>
                                </Grid>
                              );
                            })
                          )}

                          <Grid
                            item
                            xs={12}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "20px",
                            }}
                          >
                            <Button
                              className="Button"
                              disabled={!enabledButtons[index]}
                              style={{
                                fontSize: "14px",
                                color: "white",
                                width: "120px",
                                height: "40px",
                                backgroundColor: "#1976d2",
                              }}
                              onClick={() => handleSave(s)}
                            >
                              Save
                            </Button>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "20px",
                      }}
                    >
                      {/* <Button
                        className="Button"
                        disabled={!enabledButtons[index]}
                        style={{
                          fontSize: "14px",
                          color: "white",
                          width: "120px",
                          height: "40px",
                          backgroundColor: "#1976d2",
                        }}
                        onClick={() => handleSave(s)}
                      >
                        Save
                      </Button> */}

                      {rights.Delete_Templates && (
                        <IconButton onClick={() => handleDeleteTemplate(s.id)}>
                          <DeleteIcon
                            style={{
                              color: "red",
                              fontSize: "22px",
                            }}
                          />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <div style={{ margin: "5rem", textAlign: "center" }}>
                <Typography variant="h6">No Records Found</Typography>
              </div>
            )}
          </Paper>
        </Grid>
      </Container>
    </div>
  );
};
export default Template;
